import { render, staticRenderFns } from "./ProviderPayments.vue?vue&type=template&id=55eef614&scoped=true"
import script from "./ProviderPayments.vue?vue&type=script&lang=js"
export * from "./ProviderPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eef614",
  null
  
)

export default component.exports